import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, signal, ViewChild } from '@angular/core';
import { DriverTimeService } from 'app/modules/driver-time-management/services/driver-time.service';
import { ConfirmationService } from 'primeng/api';
import { AppSettings } from '../../../shared/app.settings';
import { CommonBindingDataService } from '../../../shared/services/common-binding-data.service';
import { AssignDriverScreenFilterModel } from '../../save-filter-models/assign-driver-screen-filter-model';
import { AssignDriverScreenFiltersDataModel } from '../../save-filter-models/assign-driver-screen-filters-data-model';
import { StorageService } from '../../services/storage.service';
import { UiService } from '../../services/ui.service';
import { UserCommonService } from '../../services/user-common.service';
import { MiGrid2Component } from '../mi-grid-2/mi-grid-2.component';
import { PickupLocationOptionsService } from '../../services/pickup-location-options.service';
@Component({
  selector: 'app-sidebar-assign-driver',
  templateUrl: './sidebar-assign-driver.component.html',
  styleUrls: ['./sidebar-assign-driver.component.scss'],
  providers: [DatePipe],
})
export class SidebarAssignDriverComponent implements OnInit {

  @Input() bookingDetail: any;
  @Input() fromComponent: any;
  @Output() sideBarHide: EventEmitter<any> = new EventEmitter();
  @Output() showThirdPartyPopUp: EventEmitter<any> = new EventEmitter();
  @ViewChild(MiGrid2Component) gridRef2: MiGrid2Component;

  url = '';
  recordCount = 0;
  tempUrl = '/secure/drivers/assign-trip/data/list';
  uniqId = AppSettings.UNIQID.SHARED_SIDEBA_DRIVER_52A4;
  toThirdParty = false;
  toAutoBroadcast = false;
  bookingCancelsPopup = false;
  driverId = '';
  defaultThumbnail = AppSettings.GET_FILE_THUMB_URL;
  driverList: any[] = [];
  params: any = '';
  notOutBound = true;
  shifGroupOptions = AppSettings.SHIFT_STATUS_OPTIONS;
  parkingLocationsOptions: any[] = [];
  searchText = '';
  shiftGroupStatus = AppSettings.SHIFT_STATUS_OPTIONS[1].value;
  defaultShiftGroupStatus = '';
  selectedParkingLocation: any = '';
  defaultSelectedparkingLocation: any = '';
  parkingFilterDisabled = false;
  queueFilterDisabled = false;
  shiftFilterDisabled = false;
  checkIfOutboundorSpecial = false;
  sortDisabled = false;
  inboundSubBookingType = AppSettings.SUB_BOOKINMG_SERVICE_TYPES.INBOUND;
  outboundSubBookingType = AppSettings.SUB_BOOKINMG_SERVICE_TYPES.OUTBOUND;
  allSubBookingType = AppSettings.SUB_BOOKINMG_SERVICE_TYPES.ALL;
  sortByFilter = [];
  clearSearch;
  storeUnit: string = '';
  sortByDefault = AppSettings.DRIVER_ASSIGN_SORT_KEYS[0];
  requestedSortKey = AppSettings.DRIVER_ASSIGN_SORT_KEYS[1];
  selectedVehicleType: String = '';
  defaultOrAssignedParking = '';
  defaultSelectedQueueLocation = '';
  selectedQueueLocation: String = '';
  queueLocationList = [];
  driverTypeOptions = AppSettings.DRIVER_TYPE_OPTIONS;
  selectedDriverType = '';
  selectedGroup = '';
  defaultdriverType = AppSettings.DRIVER_TYPE_OPTIONS[0].value;
  showParkingLocation = false;
  vehicleTypeList = [];
  eventIdParam;
  confirmationPopup: Boolean = false;
  confirmationMessage;
  newDriverId: any;
  isShowAssignGroup = false;
  assignSelectedQueueLocation: any;
  userId: any;
  columns: any = [];
  vehicleTypeOptions: any = [];
  searchPlaceHolder: '';
  paginationCount = AppSettings.ASSIGN_DRIVER_PAGINATION;
  originalFilterData: any;
  changedFilterData: any;
  filterApplied = false;
  filterButtonClass = 'filter-btn-apply';
  groupOptions: any[];
  selectedDispatchAddress: any = [];
  serviceCitiesOptions: any = [];
  loadGrid = signal(false);

  constructor(
    private uiService: UiService,
    private commonBindingDataService: CommonBindingDataService,
    private userCommonService: UserCommonService,
    private confirmationService: ConfirmationService,
    private storageService: StorageService,
    private driverTimeService: DriverTimeService,
    private pickupLocationOptionsService: PickupLocationOptionsService
  ) {}

  ngOnInit() {
    console.log('bookingDetail', this.bookingDetail);
    if ((this.bookingDetail.requestLabel === 'SPECIAL_REQUESTS' || this.bookingDetail.subServiceTypeStatus === 'OUTBOUND') && (this.bookingDetail &&
      this.bookingDetail.subServiceType === AppSettings.JOURNEY_TYPE_VALUES.GENERAL) && this.bookingDetail.bookingStatus == 25) {
      this.checkIfOutboundorSpecial = true;
      this.toAutoBroadcast = this.bookingDetail.autoBroadcast;
    }
    this.commonBindingDataService.eventId.subscribe(result => {
      this.eventIdParam = result;
      this.loadInitialData();
    });

    if (!this.eventIdParam) {
      let tempEventId = this.commonBindingDataService.changedEventId;
      if (tempEventId) {
        this.eventIdParam = tempEventId;
        this.loadInitialData();
      }
    }

    this.storeUnit = this.commonBindingDataService.getTenantConfigValue(AppSettings.DISTANCE_UNIT);
    this.clearSearch = this.commonBindingDataService.getLabel('label_clear_search');
    this.sortByFilter = [
      { label: this.commonBindingDataService.getLabel('label_idle_time'), value: AppSettings.DRIVER_ASSIGN_SORT_KEYS[0] },
      { label: this.commonBindingDataService.getLabel('label_near_by'), value: AppSettings.DRIVER_ASSIGN_SORT_KEYS[1] },
    ];
    this.getColumns();
  }

  loadInitialData() {
    this.getServiceCities();
    this.getVehicleTypes();
    this.getGroupList();
  }

  getColumns() {
    this.columns.push({
      field: 'driverName', width: 100, header: this.commonBindingDataService.getLabel('grid_driver'),
      sort: false, resize: true, cellRendererHtml: (i) => (this.driverNameAndStatus(i)),
    });

    this.columns.push({
      field: 'shiftDutyStatus', width: 100, header: this.commonBindingDataService.getLabel('label_shift_status'),
      sort: false, resize: true, cellRendererHtml: (i) => (this.getShiftStatus(i)),
    });

    this.columns.push({
      field: 'pFirstName', width: 140, header: this.commonBindingDataService.getLabel('label_vehicle_info'),
      sort: false, resize: true, cellRendererHtml: (i) => (this.driverInfo(i))
    });
    this.columns.push({
      field: 'pickupLocationName', width: 140, header: this.commonBindingDataService.getLabel('label_parking_queue'),
      sort: false, resize: true, cellRendererHtml: (i) => (this.driverAvailability(i))
    });

    const etaCalculatedBy = (this.commonBindingDataService.getTenantConfigValue('assign_driver_screen_eta_calculated_by') || '').toString().trim().toUpperCase();
    if (etaCalculatedBy === 'GOOGLE') {
      this.columns.push({
        field: 'distanceInMeters', width: 80, header: this.commonBindingDataService.getLabel('label_eta_to_pickup'),
        sort: false, resize: true, cellRendererHtml: (i) => (this.getEtaToPickupInfo(i))
      });
    }
    this.columns.push({
      field: '', header: this.commonBindingDataService.getLabel('label_action'),
      sort: false, resize: true, width: 80, cellRendererHtml: (i) => (this.actionCells(i))
    });
  }

  getServiceCities() {
    this.serviceCitiesOptions = [];
    this.commonBindingDataService.getCitiesV1(this.eventIdParam).subscribe(results => {
      this.serviceCitiesOptions = results.map(element => ({ label: element.cityAliasName, value: element.id }));
      this.initializeUrl();
    }, (error) => {
      error = JSON.parse(error);
    });
  }

  initializeUrl() {
    let filterData = this.gateAllFilters();
    if (filterData) {
      const localData = filterData.filterData;
      this.selectedVehicleType = localData.selectedVehicleType ? localData.selectedVehicleType : '';
      this.selectedParkingLocation = localData.selectedParkingLocation ? localData.selectedParkingLocation : '';
      this.selectedQueueLocation = localData.selectedQueueLocation ? localData.selectedQueueLocation : '';
      this.selectedDriverType = localData.selectedDriverType ? localData.selectedDriverType : '';
      this.requestedSortKey = localData.requestedSortKey ? localData.requestedSortKey : '';
      this.selectedGroup = localData.selectedGroup ? localData.selectedGroup : '';
      if (this.bookingDetail.tenantServiceAreaId) {
        const tenantServiceAreaId = String(this.bookingDetail.tenantServiceAreaId).trim();
        const matchedCity = this.serviceCitiesOptions.find(
          (city) => String(city.value).trim() === tenantServiceAreaId
        );
        this.selectedDispatchAddress = matchedCity ? [matchedCity.value] : [];
      } else if (filterData.filterData.selectedDispatchAddress) {
        this.selectedDispatchAddress = filterData.filterData.selectedDispatchAddress.split(',').map(item => item.trim())?.filter(id =>
          this.serviceCitiesOptions.some(city => city.value === id)
        );
      } else {
        this.selectedDispatchAddress = [];
      }
      this.getLocations();
      this.url = `${this.tempUrl}?tourId=${this.bookingDetail?.id}&vehicleTypeId=${this.selectedVehicleType}&parkingLocationId=${this.selectedParkingLocation}&queueLocationId=${this.selectedQueueLocation}&selectDriverFrom=${this.selectedDriverType}&listSortKey=${this.requestedSortKey}&shiftId=${this.selectedGroup}&serviceAreaId=${this.selectedDispatchAddress}`;
    } else {
      this.url = this.tempUrl + `?tourId=${this.bookingDetail?.id}`;
    }
    this.gateAndSetAllFilters();
    this.loadGrid.set(true);
  }

  getVehicleTypes() {
    this.vehicleTypeOptions.push({ label: this.commonBindingDataService.getLabel('label_all'), value: '' });
    const vehicleTypeData: any[] = this.storageService.getItemFromSessionStorage(AppSettings.VEHICLE_TYPE_DATA);
    vehicleTypeData.forEach(element => {
      this.vehicleTypeOptions.push({ label: element.vehicleType, value: element.id });
    });
  }

  private escapeHtml(text: any): string {
    const value = text === null || text === undefined ? '' : String(text);
    return value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  driverNameAndStatus(params) {
   
    const driverNameSafe = this.escapeHtml(params.name ? params.name : '');                     
    const isOnDuty = params.driverDutyStatus == 't';
    const isFree = params.driverCurrentJobStatus == 'FREE';
    const dutyDotHtml = `<span class="duty-dot ${isOnDuty ? 'on-duty' : 'off-duty'}"></span>`;
    const statusHtml = isFree ? `<span class="availableGreenText">Available</span>` : `<span class="busyRedText">Busy</span>`;
    const shift = params.shiftName ? `<span class="shift-name"> | ${params.shiftName ? params.shiftName : ''}</span>` : '';
    const shiftSlots = `<div class="greyText" title="${params.shiftSlotsStr ? params.shiftSlotsStr : '-- No Slots --'}">${params.shiftSlotsStr ? params.shiftSlotsStr : '-- No Slots --'}</div>`;
    const eDiv = document.createElement('div');
    const PreparedData = `<div class="booking-grid-table gid" title="">
    <div class="driverName pb-2">${dutyDotHtml}${driverNameSafe}</div>
    <div class="vehicleInfo pb-2">
       ${statusHtml} ${shift}
    </div>
    ${shiftSlots}
    </div>`;
    eDiv.innerHTML += PreparedData;
    return eDiv;
  }

  getTeamInfo(params) {
    const eDiv = document.createElement('div');
    const shiftName = params.shiftName ? params.shiftName : 'Team not assigned';
    const shiftNameSafe = this.escapeHtml(shiftName);
    let shiftTimeRange = '';
    if (params.shiftSlotsStr) {
     
      shiftTimeRange = params.shiftSlotsStr ? params.shiftSlotsStr : '-';
    }
    let driverName = `
    <div class="vehicleInfo pb-2">
        <div class="driverName pb-2">${shiftNameSafe}</div>
        <div class="greyText">${shiftTimeRange}</div>
    </div>`
    eDiv.innerHTML += driverName;
    return eDiv;
  }

  getShiftStatus(params) { 
    const eDiv = document.createElement('div');
    const currentShiftDutyStatusClass = params?.currentShiftDutyStatus ? 'availableGreenText' : 'busyRedText';
    const shiftDutyStatusClass = params?.shiftDutyStatus ? 'availableGreenText' : 'busyRedText';
    const PreparedData = `<div class="booking-grid-table gid" title="">
    <div class="vehicleInfo pb-2">
        <span class="greyText">Currently: <span class="${currentShiftDutyStatusClass}">${params?.currentShiftDutyStatus ? 'On Shift' : 'Off Shift'}</span></div>
      <div><span class="greyText">For Pickup : <span class="${shiftDutyStatusClass}">${params?.shiftDutyStatus ? 'On Shift' : 'Off Shift'}</span></div>
    </div>`;
    eDiv.innerHTML += PreparedData;
    return eDiv;
  }

  driverInfo(params) {
    const eDiv = document.createElement('div');
    const PreparedData = params.vehicleCode ? `<div class="booking-grid-table gid" title="">
        <div class="grid">
          ${params.wheelchairSupport ? `<img src="/assets/images/temp/wheelchair.svg" class="mt-2" width='36px' height='20px'>` : ''}
          <div class="driverName mt-2 pb-2 ${params.wheelchairSupport ? '' : 'ml-2'}">
            ${params.vehicleCode ? params.vehicleCode : ''}
            ${params.vehicleRegistration ? ` - ${params.vehicleRegistration}` : ''}
          </div>
        </div>
      <div class="greyText">${params.makeModel ? params.makeModel : ''} ${params.modelName ? params.modelName : ''} ${params.vehicleType ? ` - ${params.vehicleType}` : ''} ${params.capacity ? `<span class="greenText"> (${params.capacity})</span>` : ''}</div>
    </div>` : '<div class="booking-grid-table gid" title="">NA</div>';
    eDiv.innerHTML += PreparedData;
    return eDiv;
  }

  driverAvailability(params) {
    const eDiv = document.createElement('div');
    const PreparedData = ((params.parkingLocationId || params.queueLocationId) ? `<div class="booking-grid-table gid" title="">
    <div class="vehicleInfo pb-2">
        <span class="greyText"> ${params.parkingLocationId ? 'At Parking' : "At Queue"} : ${params.queueLocationId ? `<span class="queueLocationText" title="${params.queueLocationDisplayName}">${params.queueLocationDisplayName} ${params.queueNumber > 0 ? `(${params.queueNumber})` : ''}</span>` : `<span class="queueLocationText" title="${params.parkingLocationDisplayName}">${params.parkingLocationDisplayName}</span>`}</span></div>
      <div><span class="greyText">${params.parkingLocationId ? "Check In Since" : 'Check In Time'} : </span><span class="checkInTimeAtQueue" title="${params.parkingLocationId ? params.userAddedInParkingAtStr : params.userAddedInQueueAtStr}">${params.parkingLocationId ? params.userAddedInParkingAtStr : params.userAddedInQueueAtStr}</span></div>
    </div>` : '<div class="booking-grid-table gid" title="">NA</div>');
    eDiv.innerHTML += PreparedData;
    return eDiv;
  }

  getEtaToPickupInfo(params) {
    const eDiv = document.createElement('div');
    let etaInfo = `
                  <div class="mt-2">
                  <span class='eta-to-pickup'>NA</span>
                  </div>`;
    if (params.etaToPickupTimeStr !== null && params.etaToPickupDistanceStr !== null) {
      etaInfo = `
             <div class="mt-2">
             <div class="driverName">${params.etaToPickupTimeStr ? params.etaToPickupTimeStr : ''}
             <div class="greyText">(${params.etaToPickupDistanceStr ? params.etaToPickupDistanceStr : ''})</div>
            </div>
            </div>`;
    }

    // onOffShiftStatus
    eDiv.innerHTML += etaInfo;
    return eDiv;
  }

  actionCells(params) {
    let isDriverAssignLabel = this.commonBindingDataService.getLabel('label_assign');
    let buttonClass = 're-assign-btn p-1';
    let assignType = 'assignDriver';
    const eDiv = document.createElement('div');
    eDiv.setAttribute('class', 'grid-btn-div buttons');
    const btn = `<div>
    <div data-action-type=${assignType} class="grid-btn-div ${buttonClass}">
       ${isDriverAssignLabel} </div>
    </div>`;
    eDiv.innerHTML = btn;
    return eDiv;
  }

  onRowClicked(e: any) {
    const actionType = e.originalEvent.target.getAttribute('data-action-type');
    switch (actionType) {
      case 'assignDriver':
        return this.assignDriver(e.data);
      default:
        break;
    }
  }

  getLocations() {
    
    this.pickupLocationOptionsService.getPickupAddress(this.selectedDispatchAddress.toString(), this.eventIdParam).subscribe(result => {
    
      this.queueLocationList = result.filter(ele => ele.locationCategoryIds.includes(AppSettings.LOCATION_TYPES.QUEUE) && ele.activated).map(ele => ({ label: ele.code, value: ele.id }));
      this.queueLocationList.unshift({ label: this.commonBindingDataService.getLabel('label_all'), value: '' });
      this.parkingLocationsOptions = result.filter(ele => ele.locationCategoryIds.includes(AppSettings.LOCATION_TYPES.PARKING) && ele.activated).map(ele => ({ label: ele.code, value: ele.id }));
      this.parkingLocationsOptions.unshift({ label: this.commonBindingDataService.getLabel('label_all'), value: '' });
    });
  }

  assignDriver(driverDetails: any) {
    this.newDriverId = driverDetails.userId;
    const payload = {
      tourIdOrTripId: this.bookingDetail.id,
      driverIdOrCode: driverDetails.userId,
      reassigned: (this.bookingDetail.driverId) ? true : false,
      overridden: false
    };

    const messages: string[] = [];
    const addMessage = (line1: string, line2?: string) => {
      messages.push(line2 ? `${line1}\n${line2}` : line1);
    };

    const passengerCountValue = this.bookingDetail?.totalNoOfPassengers
      ?? this.bookingDetail?.tourBookingInfo?.totalNoOfPassengers
      ?? this.bookingDetail?.passengerCount
      ?? this.bookingDetail?.tourBookingInfo?.passengerCount;
    const passengerCount = Number(passengerCountValue);
    const capacity = Number(driverDetails?.capacity);

    const isOffDuty = driverDetails?.driverDutyStatus !== undefined && driverDetails?.driverDutyStatus !== null && driverDetails.driverDutyStatus !== 't';
    const isOffShift = driverDetails?.shiftDutyStatus === false;
    const isCapacityLowerThanPassengerCount = Number.isFinite(passengerCount) && Number.isFinite(capacity) && passengerCount > 0 && capacity > 0 && capacity < passengerCount;
    const isVehicleTypeMismatch = this.bookingDetail.vehicleType !== driverDetails.vehicleType && driverDetails.vehicleType;

    switch (true) {
      case isOffDuty:
        addMessage(
          'The selected driver is currently off duty.'
        );
        break;
      default:
        break;
    }

    switch (true) {
      case isOffShift:
        addMessage(
          'The selected driver is not scheduled to be on shift at the booking pickup time.'
        );
        break;
      default:
        break;
    }

    switch (true) {
      case isCapacityLowerThanPassengerCount:
        addMessage(
          'The booking passenger count exceeds the vehicle’s seating capacity.',
        );
        break;
      default:
        break;
    }

    switch (true) {
      case isVehicleTypeMismatch:
        addMessage(
          `This is ${this.bookingDetail.vehicleType} booking.`,
          `Do you want to assign it to ${driverDetails.vehicleType}?`
        );
        break;
      default:
        break;
    }

    const numberedMessages = messages.map((message, index) => {
      const lines = message.split('\n');
      const firstLine = `${index + 1}. ${lines[0]}`;
      const restLines = lines.slice(1).map((line) => `   ${line}`);
      return [firstLine, ...restLines].join('\n');
    });

    const confirmationMessage = [
      ...(numberedMessages.length > 0 ? [numberedMessages.join('\n\n')] : []),
      'Do you want to proceed with this assignment?'
    ].join('\n\n');

    this.confirmationService.confirm({
      message: confirmationMessage,
      accept: () => {
        this.callAssignApi(payload);
      }
    });
  }

  callAssignApi(data) {
    const assignObservable = this.commonBindingDataService.driverAssigned(data);
    assignObservable.subscribe(results => {
      const status = (results && results.status) ? (results.status + '').toUpperCase() : 'SUCCESS';
      const message = (results && results.general && results.general[0] && results.general[0].message)
        ? results.general[0].message
        : (results && results.message) ? results.message : '';

      if (results && results.showAlert) {
        this.confirmationPopup = true
        this.confirmationMessage = message
      } else if (status === 'ERROR') {
        this.uiService.showMessage(message, AppSettings.MESSAGE_TYPE.ERROR);
        this.successSave('success', results);
      } else {
        this.uiService.showMessage(message || 'Success', AppSettings.MESSAGE_TYPE.SUCCESS);
        this.successSave('success', results);
      }
    }, (error) => {
      const errMsg = (error && error.general && error.general[0] && error.general[0].message)
        ? error.general[0].message
        : (error && error.message) ? error.message : 'Something went wrong';
      this.uiService.showMessage(errMsg, AppSettings.MESSAGE_TYPE.ERROR);
      if (error.general[0].messageCode !== 'failure.driverBusyStatus') {
        this.successSave('error', error);
      }
    });
  }

  confirmCancellationReason() {
    const isMergedRide = this.bookingDetail && this.bookingDetail.mergedRide === true;
    const payload = isMergedRide ? {
      tourId: this.bookingDetail.id,
      mergeGroupId: this.bookingDetail.mergeGroupId,
      driverIdOrCode: this.newDriverId,
      reassigned: (this.bookingDetail.driverId) ? true : false,
      overridden: true
    } : {
      tourIdOrTripId: this.bookingDetail.id,
      driverIdOrCode: this.newDriverId,
      reassigned: (this.bookingDetail.driverId) ? true : false,
      overridden: true
    };

    this.callAssignApi(payload);
  }

  closeCancellationReason() {
    this.confirmationPopup = false
    this.confirmationMessage = ''
  }

  successSave(messsage, results) {
    setTimeout(() => {
      this.commonBindingDataService.bookingTabCountChange.next(true);
      this.sideBarHide.emit();
    }, 500);
  }

  isAutoBroadcastAssign() {
    if (this.bookingDetail.luggageTour == true || (this.bookingDetail.luggageVehicleRequire == true && this.bookingDetail.luggageTourAction != "reject")) {
      return false;
    } else {
      return true;
    }
  }

  onSwitchChange(event) {
    let message = '';
    if (event.checked) {
      message = this.commonBindingDataService.getLabel('label_autobroadcast_confirm');
    } else {
      message = this.commonBindingDataService.getLabel('label_autobroadcast_reject');
    }
    this.confirmationService.confirm({
      message: message,
      accept: () => {
        const data = {
          autoBroadcast: event.checked,
        };
        this.commonBindingDataService.AssigneToAutobroadcast(this.bookingDetail.id, data).subscribe(results => {
          this.successSave('success', results);
          this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS);
        }, (error) => {
          this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
        });
      },
      reject: () => {
        this.toAutoBroadcast = !this.toAutoBroadcast;
      }
    });
  }

  checkParkingAndQueue(key: any) {
    if (key == "selectedQueueLocation" && (this.selectedQueueLocation != '' || null)) {
      this.selectedParkingLocation = null
    } else if (key == "selectedParkingLocation" && (this.selectedParkingLocation != '' || null)) {
      this.selectedQueueLocation = null
    }
  }

  onclickFilterApply(key: any) {
    this.applyFilter();
  }

  applyFilter(key?: any) {
    this.filterApplied = true
    this.params = '';
    if (this.selectedVehicleType !== undefined && this.selectedVehicleType !== null) {
      this.params += (`&vehicleTypeId=${this.selectedVehicleType}`);
    }
    if (this.selectedParkingLocation !== undefined && this.selectedParkingLocation !== null) {
      this.params += (`&parkingLocationId=${this.selectedParkingLocation}`);
    }
    if (this.selectedQueueLocation !== undefined && this.selectedQueueLocation !== null) {
      this.params += (`&queueLocationId=${this.selectedQueueLocation}`);
    }
    if (this.selectedDriverType !== undefined && this.selectedDriverType !== null) {
      this.params += (`&selectDriverFrom=${this.selectedDriverType}`);
    }
    if (this.requestedSortKey !== undefined && this.requestedSortKey !== null) {
      this.params += (`&listSortKey=${this.requestedSortKey}`);
    }
    if (this.selectedGroup !== undefined && this.selectedGroup !== null) {
      this.params += (`&shiftId=${this.selectedGroup}`);
    }
    if (this.selectedDispatchAddress !== undefined && this.selectedDispatchAddress !== null) {
      this.params += (`&serviceAreaId=${this.selectedDispatchAddress}`);
    }
    this.reloadGrid();
    if (key != "callOnlyApi") {
      this.updateSaveFilter();
    }
  }

  reloadGrid() {
    const nextUrl = this.tempUrl + `?tourId=${this.bookingDetail.id}` + this.params;
    this.url = nextUrl;
    if (this.gridRef2 && typeof this.gridRef2.updateUrl === 'function') {
      this.gridRef2.updateUrl(nextUrl);
    }
  }

  resetFilter() {
    this.toAutoBroadcast = false;
    this.selectedDriverType = 'all';
    this.selectedParkingLocation = '';
    this.selectedQueueLocation = '';
    this.requestedSortKey = AppSettings.DRIVER_ASSIGN_SORT_KEYS[1];
    this.selectedVehicleType = '';
    this.selectedGroup = '';
    this.selectedDispatchAddress = [];
    this.params = `&listSortKey=${this.requestedSortKey}&shiftId=${this.selectedGroup}`;
    this.reloadGrid();
    this.updateSaveFilter();
    this.getLocations();
  }

  updateSaveFilter() {
    const saveFilterModel = new AssignDriverScreenFilterModel({
      screenCode: AppSettings.FILTER_SCREEN_CODE.BOOKING_ASSIGN_DRIVER,
      eventId: this.userCommonService.getActiveEventId(),
      filterData: new AssignDriverScreenFiltersDataModel({
        selectedVehicleType: this.selectedVehicleType,
        selectedParkingLocation: this.selectedParkingLocation,
        selectedQueueLocation: this.selectedQueueLocation,
        selectedDriverType: this.selectedDriverType,
        requestedSortKey: this.requestedSortKey,
        selectedGroup: this.selectedGroup,
        selectedDispatchAddress: this.selectedDispatchAddress.toString(),
      }),
    });

    this.userCommonService.updateSavedFilter(saveFilterModel).subscribe(result => {
      this.userCommonService.updateFilterDataToLocal(result);
      setTimeout(() => {
        this.gateAndSetAllFilters();
      }, 100);
      this.filterApplied = false;
    });
  }

  gateAndSetAllFilters() {
    this.gateAllFilters();
    this.makeAllFilterToString();
  }

  gateAllFilters() {
    let filterData: AssignDriverScreenFilterModel = this.userCommonService.getSavedFilters(AppSettings.FILTER_SCREEN_CODE.BOOKING_ASSIGN_DRIVER, this.userCommonService.getActiveEventId());
    if (filterData) {
      let localData = filterData.filterData;
      this.originalFilterData = localData;
      this.changedFilterData = { ...localData };
      return filterData;
    } else {
      setTimeout(() => {
        this.resetFilter();
      }, 100);
      return null;
    }
  }

  makeAllFilterToString() {
    if (this.originalFilterData) {
      let keys = Object.keys(this.originalFilterData);
      for (let i = 0; i < keys.length; i++) {
        this.changedFilterData[keys[i]] = this.changedFilterData[keys[i]] ? this.changedFilterData[keys[i]] : '';
        this.originalFilterData[keys[i]] = this.originalFilterData[keys[i]] ? this.originalFilterData[keys[i]] : '';
      }
    }
  }

  changeFilter(key?, val?) {

    this.changedFilterData[key] = val.toString();
    let changedValues = [];
    let keys = Object.keys(this.originalFilterData);
    for (let i = 0; i < keys.length; i++) {
      if (this.originalFilterData[keys[i]] !== this.changedFilterData[keys[i]]) {
        changedValues.push(keys[i]);
      }
    }
    this.filterApplied = false;
    if (changedValues.length > 0) {
      this.filterApplied = true;
    }
    if (key == "selectedDispatchAddress") {
      this.getLocations();
    }
  }

  totalCount(event: any) {
    this.recordCount = event;
  }

  getGroupList() {
    this.driverTimeService.getDriverScheduleGroups(this.eventIdParam).subscribe(data => {
      this.groupOptions = [{ name: 'All', id: '' }];
      this.groupOptions = [...this.groupOptions, ...data];
      this.groupOptions = this.groupOptions.map(({
        id: value,
        name: label,
        ...rest
      }) => ({
        value,
        label,
        ...rest
      }));
    });
  }
}